import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { MissionLight } from '@wwf/sdk';
import { MissionCalendarItem } from '../MissionCalendarItem';
import { MissionEmpty } from '../../list/MissionEmpty';

interface MissionCalendarDayViewProps {
    missions: MissionLight[];
    rangeStart: Date;
    rangeEnd: Date;
}

export const MissionCalendarDayView = ({
    missions,
    rangeStart,
}: MissionCalendarDayViewProps) => {
    // We already know missions overlap with this day because of the parent filter
    const dayMissions = missions.filter(m => {
        const mStart = parseISO(m.startDate!);
        const mEnd = m.endDate ? parseISO(m.endDate) : mStart;

        const dString = format(rangeStart, 'yyyy-MM-dd');
        const sString = format(mStart, 'yyyy-MM-dd');
        const eString = format(mEnd, 'yyyy-MM-dd');

        return dString >= sString && dString <= eString;
    });

    if (dayMissions.length === 0) {
        return <MissionEmpty />;
    }

    return (
        <Box p={3} minHeight={600} bgcolor="background.paper">
            <Typography variant="h6" gutterBottom>
                {dayMissions.length} Mission{dayMissions.length > 1 ? 's' : ''}{' '}
                on {format(rangeStart, 'EEEE, MMMM d, yyyy')}
            </Typography>

            <Box
                display="grid"
                gap={2}
                gridTemplateColumns="repeat(auto-fill, minmax(300px, 1fr))"
                mt={2}
            >
                {dayMissions.map(m => (
                    <Box key={m.id} sx={{ '& > *': { height: '100%' } }}>
                        <MissionCalendarItem mission={m} viewMode="day" />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
